import {
  COLLECTION_ERRORS,
  CollectionValidationError,
  MAX_COLLECTION_FILE_BYTES,
  exportCollection,
  importCollection,
  type CardCollection,
} from "../shared/collections";

export { exportCollection, importCollection };

export function collectionExportFilename(collection: CardCollection): string {
  const name = collection.name.normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/gi, "-").replace(/^-+|-+$/g, "").toLowerCase().slice(0, 60);
  return `virou-${name || "mon-jeu"}.virou.json`;
}

export async function readCollectionFile(file: File): Promise<CardCollection> {
  if (file.size > MAX_COLLECTION_FILE_BYTES) throw new CollectionValidationError([COLLECTION_ERRORS.fileSize]);
  return importCollection(await file.text());
}

export function downloadCollection(collection: CardCollection): void {
  const blob = new Blob([exportCollection(collection)], { type: "application/json;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = collectionExportFilename(collection);
  document.body.append(link);
  link.click();
  link.remove();
  // Some mobile browsers begin the download asynchronously after the click.
  setTimeout(() => URL.revokeObjectURL(url), 30_000);
}
